import { toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "er-calculator" }
const _hoisted_2 = { class: "er-calculator" }
const _hoisted_3 = { class: "with-tooltip" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "tooltip" }
const _hoisted_6 = { colspan: "2" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "result-row" }
const _hoisted_16 = { colspan: "2" }
const _hoisted_17 = { colspan: "2" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { class: "label-row" }
const _hoisted_20 = { colspan: "2" }
const _hoisted_21 = { colspan: "4" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "with-tooltip" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "tooltip" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { colspan: "2" }
const _hoisted_29 = {
  key: 0,
  class: "label-row"
}
const _hoisted_30 = { colspan: "2" }
const _hoisted_31 = { colspan: "4" }
const _hoisted_32 = {
  colspan: "2",
  class: "with-tooltip"
}
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "tooltip" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { colspan: "2" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { colspan: "2" }
const _hoisted_40 = ["src", "alt", "onClick"]
const _hoisted_41 = { class: "tooltip" }
const _hoisted_42 = { class: "supply-from-enemy" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { class: "message-area" }
const _hoisted_46 = { class: "character" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "message-area" }
const _hoisted_49 = {
  class: "toggle-switch",
  for: "show-usage-toggle"
}
const _hoisted_50 = { style: {"text-align":"left"} }
const _hoisted_51 = { style: {"text-align":"center"} }
const _hoisted_52 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_ctx.displayName('ローテーションの長さ(秒)')) + " ", 1),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rotationLength) = $event)),
          min: "10",
          max: "180",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.rotationLength]
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[9] || (_cache[9] = _createElementVNode("th", { colspan: "2" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _ctx.characterImgSrc(element.character),
                  alt: _ctx.displayName(element.character),
                  class: "character"
                }, null, 8, _hoisted_4),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.displayName(element.character)), 1)
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.displayName('元素爆発')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((element.energyCost) = $event)
              }, null, 8, _hoisted_7), [
                [_vModelText, element.energyCost]
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.displayName('命ノ星座')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((element.constellation) = $event),
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6], (constellation) => {
                  return _createElementVNode("option", {
                    key: constellation,
                    value: constellation
                  }, _toDisplayString('C' + constellation), 9, _hoisted_10)
                }), 64))
              ], 40, _hoisted_9), [
                [_vModelSelect, element.constellation]
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.displayName('武器')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass('weapon' + _ctx.bgColorClass(index))
            }, [
              _createElementVNode("img", {
                src: _ctx.weaponImgSrc(element.character, element.currentWeapon),
                alt: _ctx.displayName(element.currentWeapon),
                class: "input-item-weapon"
              }, null, 8, _hoisted_12),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((element.weaponRefine) = $event),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (refine) => {
                  return _createElementVNode("option", {
                    key: refine,
                    value: refine
                  }, _toDisplayString('R' + refine), 9, _hoisted_14)
                }), 64))
              ], 40, _hoisted_13), [
                [_vModelSelect, element.weaponRefine]
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", _hoisted_15, [
          _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.displayName('元素チャージ効率')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.energyRechargeGls, (value, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, _toDisplayString(value + '%'), 3))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.displayName('出場時間(%)')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((element.onField) = $event),
                min: "0",
                max: "100",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
              }, null, 40, _hoisted_18), [
                [_vModelText, element.onField]
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", _hoisted_19, [
          _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.displayName('元素粒子')), 1),
          _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.displayName('獲得数')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputRowParticleEnemy, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            class: _normalizeClass(_ctx.bgColorClass2(row))
          }, [
            _createElementVNode("th", null, _toDisplayString(_ctx.displayName('敵')), 1),
            _createElementVNode("td", null, _toDisplayString(Math.round(row.currentValues.reduce((p, c) => p + c, 0) * 10) / 10), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: row.currentValues.length }, (_, i) => i), (columnIndex) => {
              return (_openBlock(), _createElementBlock("td", { key: columnIndex }, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((row.currentValues[columnIndex]) = $event),
                  min: "0"
                }, null, 8, _hoisted_22), [
                  [_vModelText, row.currentValues[columnIndex]]
                ])
              ]))
            }), 128))
          ], 2))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputRowParticle, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            class: _normalizeClass(_ctx.bgColorClass2(row))
          }, [
            _createElementVNode("th", _hoisted_23, [
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: _ctx.rowImgSrc1(row),
                  alt: _ctx.displayName(row.character),
                  class: _normalizeClass(_ctx.rowImgSrc1Class(row))
                }, null, 10, _hoisted_24),
                _createElementVNode("img", {
                  src: _ctx.rowImgSrc2(row),
                  alt: _ctx.displayName(row.triggerName),
                  class: "input-item"
                }, null, 8, _hoisted_25)
              ]),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.displayName(row.character) + ' ' + _ctx.displayName(_ctx.triggerName(row))), 1)
            ]),
            _createElementVNode("td", null, _toDisplayString(Math.round(row.currentValues.reduce((p, c) => p + c, 0) * 100) / 100), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: row.currentValues.length }, (_, i) => i), (columnIndex) => {
              return (_openBlock(), _createElementBlock("td", { key: columnIndex }, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((row.currentValues[columnIndex]) = $event),
                  min: "0"
                }, null, 8, _hoisted_27), [
                  [_vModelText, row.currentValues[columnIndex]]
                ])
              ]))
            }), 128))
          ], 2))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.displayName('元素チャージ')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.particleRecharges, (value, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: "result"
            }, _toDisplayString(value), 1))
          }), 128))
        ]),
        (_ctx.inputRowEnergy.length)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
              _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.displayName('元素エネルギー')), 1),
              _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.displayName('獲得量')), 1)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputRowEnergy, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            class: _normalizeClass(_ctx.bgColorClass2(row))
          }, [
            _createElementVNode("th", _hoisted_32, [
              _createElementVNode("span", null, [
                _createElementVNode("img", {
                  src: _ctx.rowImgSrc1(row),
                  alt: _ctx.displayName(row.character),
                  class: _normalizeClass(_ctx.rowImgSrc1Class(row))
                }, null, 10, _hoisted_33),
                _createElementVNode("img", {
                  src: _ctx.rowImgSrc2(row),
                  alt: _ctx.displayName(row.triggerName),
                  class: "input-item"
                }, null, 8, _hoisted_34)
              ]),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.displayName(row.character) + ' ' + _ctx.displayName(_ctx.triggerName(row))), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: row.currentValues.length }, (_, i) => i), (columnIndex) => {
              return (_openBlock(), _createElementBlock("td", { key: columnIndex }, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((row.currentValues[columnIndex]) = $event),
                  min: "0"
                }, null, 8, _hoisted_36), [
                  [_vModelText, row.currentValues[columnIndex]]
                ])
              ]))
            }), 128))
          ], 2))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.displayName('元素爆発(回数)')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: _ctx.calculatorInput.length }, (_, i) => i), (index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((_ctx.burstCounts[index]) = $event),
                min: "0"
              }, null, 8, _hoisted_38), [
                [_vModelText, _ctx.burstCounts[index]]
              ])
            ], 2))
          }), 128))
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.displayName('武器変更')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatorInput, (element, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: index,
              class: _normalizeClass(_ctx.bgColorClass(index))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.replaceWeapons, (weapon, weaponIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: weaponIndex,
                  class: "with-tooltip"
                }, [
                  _createElementVNode("img", {
                    src: _ctx.replaceWeaponImgSrc(element, weapon),
                    alt: _ctx.displayName(weapon),
                    class: _normalizeClass('input-item-weapon' + _ctx.replaceWeaponClass(element, weapon)),
                    onClick: ($event: any) => (_ctx.replaceWeaponOnClick(element, weapon))
                  }, null, 10, _hoisted_40),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.displayName(weapon)), 1)
                ]))
              }), 128))
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(_ctx.displayName('戦闘の長さ(秒)')) + " ", 1),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.combatLength) = $event)),
          min: "1",
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.inputOnChange && _ctx.inputOnChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.combatLength]
        ])
      ]),
      _createElementVNode("table", _hoisted_42, [
        _createElementVNode("caption", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOpenSupplyFromEnemy = !_ctx.isOpenSupplyFromEnemy))
        }, _toDisplayString(_ctx.isOpenSupplyFromEnemy ? '-' : '+') + " " + _toDisplayString(_ctx.displayName('敵')) + " " + _toDisplayString(_ctx.isOpenSupplyFromEnemy ? '-' : '+'), 1),
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[10] || (_cache[10] = _createElementVNode("th", null, null, -1)),
            _createElementVNode("th", null, _toDisplayString(_ctx.displayName('元素オーブ')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.displayName('元素粒子')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplyFromEnemy, (element, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("th", null, _toDisplayString(_ctx.displayName(element[0])), 1),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((element[1]) = $event),
                  min: "0"
                }, null, 8, _hoisted_43), [
                  [_vModelText, element[1]]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((element[2]) = $event),
                  min: "0"
                }, null, 8, _hoisted_44), [
                  [_vModelText, element[2]]
                ])
              ])
            ])), [
              [_vShow, _ctx.isOpenSupplyFromEnemy || element[1] || element[2]]
            ])
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createElementBlock("p", { key: index }, [
          _createElementVNode("span", _hoisted_46, _toDisplayString(message[0]), 1),
          _cache[11] || (_cache[11] = _createTextVNode("   ")),
          _createElementVNode("span", null, _toDisplayString(message[1]), 1),
          (message[0] || message[1])
            ? (_openBlock(), _createElementBlock("br", _hoisted_47))
            : _createCommentVNode("", true),
          _createTextVNode("   " + _toDisplayString(message[2]), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, [
          _withDirectives(_createElementVNode("input", {
            class: "hidden",
            type: "checkbox",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isShowUsage) = $event)),
            id: "show-usage-toggle"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isShowUsage]
          ]),
          _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.displayName('元素チャージ効率計算機能について')), 1)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.displayName('前提')), 1),
          _cache[19] || (_cache[19] = _createElementVNode("ol", null, [
            _createElementVNode("li", null, "元素チャージ効率が変動するタイプの天賦や命ノ星座は考慮しません。 "),
            _createElementVNode("li", null, "HP等ステータスの現在値を条件にして発動するタイプの天賦や命ノ星座は無視するか、最小の発動回数で計算します。"),
            _createElementVNode("li", null, "敵の数は1。"),
            _createElementVNode("li", null, [
              _createTextVNode("天賦および命ノ星座によって獲得できる元素エネルギーを計算する際に、キャラクターの天賦レベルやステータスを参照する場合、キャラクターのステータス、天賦レベル、武器、聖遺物はげんかるくのセーブデータを使用します。 セーブデータが存在しない場合は、天賦レベル8、武器と聖遺物なしのステータスで計算します。"),
              _createElementVNode("br")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.displayName('ローテーションの読み方')), 1),
          _createElementVNode("ol", null, [
            _cache[17] || (_cache[17] = _createStaticVNode("<li data-v-7de6944e>ローテーションの長さ<br data-v-7de6944e> ローテーションに存在する元素スキルのクールタイムまたは元素爆発のクールタイムから決定します。 元素スキルの発動回数は考慮しませんが、元素爆発の方は発動回数に応じて加算します。 初期値は20秒。 </li><li data-v-7de6944e>出場時間<br data-v-7de6944e> ローテーションの内容から大雑把に計算して割り当てます。 キャラクター毎アクション毎の所要時間のデータを持たないため、正確ではありません。 </li><li data-v-7de6944e>大部分のキャラクターの元素スキル<br data-v-7de6944e> 元素スキル命中時に元素粒子が発生するタイプの元素スキルは、直後のアクション実行者が元素粒子を獲得します。 </li><li data-v-7de6944e>胡桃、宵宮、神里綾人、放浪者 等の元素スキル<br data-v-7de6944e> 元素スキル使用時に元素粒子が発生せず、その後の通常攻撃または重撃命中時に元素粒子が発生するタイプの元素スキルは、継続時間一杯攻撃した場合に発生するであろう数の元素粒子を実行者自身が獲得します。 </li><li data-v-7de6944e>フィッシュル、鍾離、アルベド、八重神子 等の元素スキル<br data-v-7de6944e> 存在時間の長い設置物からの攻撃命中時に元素粒子が発生するタイプの元素スキルは、ローテーションまたは継続時間の間ずっと攻撃し続けた場合に発生するであろう数の元素粒子を出場時間を基準に全員に按分します。 また、設置系でない雷電将軍とナヒーダも同様の扱いとします。 </li><li data-v-7de6944e>アンバー、香菱、モナ、甘雨 等の元素スキル<br data-v-7de6944e> 存在時間の短い設置物からの攻撃命中または設置物が破壊された時に元素粒子が発生するタイプの元素スキルについても同様に出場時間を基準に全員に按分するが、存在時間の短さから実戦との乖離が大きくなります。(妥協) </li><li data-v-7de6944e>雷元素共鳴が生成する元素粒子<br data-v-7de6944e> ローテーションの間クールタイムの5秒間隔で雷元素関連反応が起き続けた場合に発生するであろう数の元素粒子を出場時間を基準に全員に按分します。 チーム内に対象となる元素反応を起こせる元素のキャラクターが存在しない場合は0。 </li><li data-v-7de6944e>西風武器が生成する元素粒子<br data-v-7de6944e> 使用者の出場回数および出場時間(%)、ローテーションの長さから武器効果をトリガーする回数を決定します。 トリガー回数はローテーションの長さを武器効果のクールタイムで割った数までとします。 元素粒子は基本的に装備者が獲得するが、装備者が1アクションだけで退場する場合は次のアクション実行者が獲得します。 </li><li data-v-7de6944e>通常攻撃、重撃命中時に獲得する元素エネルギー<br data-v-7de6944e> 通常攻撃または重撃の回数に応じて元素エネルギーを獲得します。 元素エネルギーを獲得する攻撃回数は武器タイプ毎に異なります。 </li>", 9)),
            _createElementVNode("li", null, [
              _cache[13] || (_cache[13] = _createTextVNode("以下、元素爆発の実行から退場するまでの間、元素スキルの元素粒子生成数を変更します。 再出場時に元の生成数に戻ります。 ")),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHARACTER_E_DECREMENT_IN_BURST, (character, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.displayName(character)), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("li", null, [
              _cache[14] || (_cache[14] = _createTextVNode("以下、元素スキルの実行から特定のアクションを実行するまでを1回の元素スキルとみなします。 ")),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHARACTER_E_UNTIL_MAP.entries(), ([character, untilMap], index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.displayName(character) + ' : ' + _ctx.actionName('E') + '⇒' +
                                        Array.from(untilMap.entries())
                                            .map(value => value[0]
                                                .map(action => _ctx.actionName(action)).join(_ctx.displayName('または'))
                                                + '×' + value[1] + _ctx.displayName('回')).join(_ctx.displayName('または'))), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("li", null, [
              _cache[15] || (_cache[15] = _createTextVNode("以下、元素スキルの実行後に特定のアクションを実行すると元素粒子を生成したとみなします。 ")),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHARACTER_E_DELAY_MAP.entries(), ([character, delayArr], index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.displayName(character) + ' : ' + _ctx.actionName('E') + '⇒' +
                                        delayArr.map(action => _ctx.actionName(action)).join(_ctx.displayName('または'))), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("li", null, [
              _cache[16] || (_cache[16] = _createTextVNode("以下、元素爆発の直前の元素スキルの元素粒子生成数を0に変更します。 ")),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CHARACTER_Q_NOT_RECHARGEABLE, (character, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.displayName(character)), 1))
                }), 128))
              ])
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("li", null, [
              _createTextVNode("以下、それぞれの条件で元素粒子の生成数を固定しています。 "),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "タルタリヤ : 双剣モード9秒程度"),
                _createElementVNode("li", null, "鹿野院平蔵 : 変格4(正論)"),
                _createElementVNode("li", null, "アルハイゼン : 光幕攻撃6回"),
                _createElementVNode("li", null, "フレミネ : 圧力ランク3以下")
              ])
            ], -1))
          ])
        ], 512), [
          [_vShow, _ctx.isShowUsage]
        ])
      ])
    ])
  ]))
}